export default{

    player : null
}